<div class="staff-requests-page">
  <div class="header">
    <h2>Staff Requests</h2>
  </div>

  <div class="request-form-card mat-elevation-z1" *ngIf="canCreateRequest()">
    <h3>Submit New Request</h3>
    <form [formGroup]="requestForm" class="grid">
      <mat-form-field appearance="outline">
        <mat-label>Request Type</mat-label>
        <mat-select formControlName="requestType">
          <mat-option value="Leave">Leave</mat-option>
          <mat-option value="Funds">Funds</mat-option>
          <mat-option value="Loan">Loan</mat-option>
          <mat-option value="Other">Other</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Direct To</mat-label>
        <mat-select formControlName="directedToStaffId">
          <mat-option [value]="null">Select staff</mat-option>
          <mat-option *ngFor="let target of requestTargets" [value]="target.id">
            {{ target.fullName }} ({{ target.position }})
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="isFundsOrLoan">
        <mat-label>Amount</mat-label>
        <input matInput type="number" formControlName="amount" />
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="isLeave">
        <mat-label>Start Date</mat-label>
        <input matInput type="date" formControlName="startDate" />
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="isLeave">
        <mat-label>End Date</mat-label>
        <input matInput type="date" formControlName="endDate" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="wide">
        <mat-label>Description</mat-label>
        <textarea matInput rows="2" formControlName="description"></textarea>
      </mat-form-field>
    </form>
    <div class="actions">
      <button mat-flat-button color="primary" (click)="submitRequest()">Submit Request</button>
    </div>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div class="table-card mat-elevation-z1">
    <h3>My Requests</h3>
    <table mat-table [dataSource]="myRequestsDataSource" class="full-table">
      <ng-container matColumnDef="requestedAt">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let r">{{ r.requestedAt | date:'medium' }}</td>
      </ng-container>
      <ng-container matColumnDef="requestType">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let r">{{ r.requestType }}</td>
      </ng-container>
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Title</th>
        <td mat-cell *matCellDef="let r">{{ r.title }}</td>
      </ng-container>
      <ng-container matColumnDef="directedTo">
        <th mat-header-cell *matHeaderCellDef>Direct To</th>
        <td mat-cell *matCellDef="let r">{{ r.directedToStaffName || '-' }}</td>
      </ng-container>
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let r">{{ r.amount ? ('₦' + (r.amount | number)) : '-' }}</td>
      </ng-container>
      <ng-container matColumnDef="period">
        <th mat-header-cell *matHeaderCellDef>Period</th>
        <td mat-cell *matCellDef="let r">
          {{ r.startDate ? (r.startDate | date:'shortDate') : '-' }} -
          {{ r.endDate ? (r.endDate | date:'shortDate') : '-' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let r">
          <span class="status" [class.pending]="r.status === 'Pending'" [class.approved]="r.status === 'Approved'" [class.rejected]="r.status === 'Rejected'">
            {{ r.status }}
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="reviewComment">
        <th mat-header-cell *matHeaderCellDef>Review Note</th>
        <td mat-cell *matCellDef="let r">{{ r.reviewComment || '-' }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="myColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: myColumns"></tr>
    </table>
    <mat-paginator #myPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
  </div>

  <div class="table-card mat-elevation-z1" *ngIf="canApprove()">
    <h3>Pending Approvals</h3>
    <table mat-table [dataSource]="approvalDataSource" class="full-table">
      <ng-container matColumnDef="requestedAt">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let r">{{ r.requestedAt | date:'medium' }}</td>
      </ng-container>
      <ng-container matColumnDef="staffName">
        <th mat-header-cell *matHeaderCellDef>Staff</th>
        <td mat-cell *matCellDef="let r">{{ r.staffName }}</td>
      </ng-container>
      <ng-container matColumnDef="requestType">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let r">{{ r.requestType }}</td>
      </ng-container>
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>Title</th>
        <td mat-cell *matCellDef="let r">{{ r.title }}</td>
      </ng-container>
      <ng-container matColumnDef="directedTo">
        <th mat-header-cell *matHeaderCellDef>Direct To</th>
        <td mat-cell *matCellDef="let r">{{ r.directedToStaffName || '-' }}</td>
      </ng-container>
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let r">{{ r.amount ? ('₦' + (r.amount | number)) : '-' }}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let r">{{ r.status }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let r">
          <button mat-icon-button [matMenuTriggerFor]="approvalMenu">
            <mat-icon>menu</mat-icon>
          </button>
          <mat-menu #approvalMenu="matMenu">
            <button mat-menu-item (click)="approve(r)">
              <mat-icon>check_circle</mat-icon>
              <span>Approve</span>
            </button>
            <button mat-menu-item (click)="reject(r)">
              <mat-icon>cancel</mat-icon>
              <span>Reject</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="approvalColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: approvalColumns"></tr>
    </table>
    <mat-paginator #approvalPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
  </div>
</div>
